import { render, staticRenderFns } from "./iframe-page-creation.vue?vue&type=template&id=6a63955a&scoped=true"
import script from "./iframe-page-creation.vue?vue&type=script&lang=js"
export * from "./iframe-page-creation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63955a",
  null
  
)

export default component.exports